/**
 * @generated SignedSource<<fb25370bce5beba99d83423e1613b18b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AsanaIntegrationAddProjectContent_viewer$data = {
  readonly integrations: {
    readonly asana: {
      readonly workspaces: ReadonlyArray<{
        readonly externalId: string;
        readonly id: string;
        readonly name: string;
      }> | null;
    } | null;
  };
  readonly " $fragmentType": "AsanaIntegrationAddProjectContent_viewer";
};
export type AsanaIntegrationAddProjectContent_viewer$key = {
  readonly " $data"?: AsanaIntegrationAddProjectContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AsanaIntegrationAddProjectContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AsanaIntegrationAddProjectContent_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaUserNode",
          "kind": "LinkedField",
          "name": "asana",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AsanaWorkspaceNode",
              "kind": "LinkedField",
              "name": "workspaces",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "38d94a02c8bf80ae04a9e42a95d0f651";

export default node;
